export default "__VITE_ASSET__8e155f9b__"